module.exports = __webpack_public_path__ + "img/facebook.231a522b.svg";